import { message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetReadNotification } from './useSetReadNotification.ts';

interface IUseMarkNotificationAsReadOptions {
  notificationId: string;
  /** dataPresaVisione — se truthy, la notifica è già stata letta */
  read?: Date | string | null;
}

/**
 * Hook di alto livello per segnare una singola notifica come letta.
 * Include guard check, gestione errori e stato di caricamento.
 */
export function useMarkNotificationAsRead(
  options: IUseMarkNotificationAsReadOptions,
) {
  const { notificationId, read } = options;
  const { t } = useTranslation();
  const mutation = useSetReadNotification(notificationId ?? '');

  const markAsRead = useCallback(async () => {
    if (read || !notificationId) return;

    try {
      await mutation.mutateAsync({ idNotifica: notificationId });
    } catch (e) {
      // biome-ignore format: <tbd>
      console.error('[useMarkNotificationAsRead] Errore durante la lettura della notifica.', { error: e });
      // biome-ignore format: <tbd>
      message.error(t('notification.error', 'Si è verificato un errore, riprovare.'));
    }
  }, [mutation, notificationId, read, t]);

  return {
    markAsRead,
    isLoading: mutation.isLoading,
    isRead: !!read,
  };
}
